import React from 'react'
import PropTypes from 'prop-types'
import { Result, Button, Layout } from 'antd'
import { useHistory } from 'react-router-dom'

const Exception = ({ code = '500' }) => {
  const history = useHistory()
  const subtitles = {
    403: 'Sorry, you are not authorized to access this page.',
    404: 'Sorry, the page you visited does not exist.',
    500: 'Sorry, something went wrong.',
  }
  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Result
        // @ts-ignore
        status={code}
        title={code}
        subTitle={subtitles[code]}
        extra={
          <Button type="primary" onClick={() => history.replace('/')}>
            Back to Home
          </Button>
        }
      />
    </Layout>
  )
}

Exception.propTypes = {
  code: PropTypes.string,
}

export default Exception
